import parse from "html-react-parser";
import moment from "moment";
import React, { useState, useRef } from "react";
import { Calendar, Edit, X, Flag } from "react-feather";
import { Helmet } from "react-helmet";
import { withRouter } from "react-router";
import { Button, Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import { humanDateFormat, puntajes, npsColors } from "../../../config/constants";
import { Activities } from "../../components/Activities";
import { BlurSpinner } from "../../components/BlurSpinner";
import Breadcrumb from "../../components/common/breadcrumb";
import { StyledSelect } from "../../components/StyledSelect";
import useFetcher from "../../hooks/useFetcher";
import useMutter from "../../hooks/useMutter";
import { fetchEncuesta, fetchEncuestaCategories, patchEncuesta } from "../../services/encuestasServices";

const retriveEncuestaObj = (itemId, location) => {
  let encuesta;
  let isLoading;
  let setEncuesta;

  if (location.state && location.state.encuesta) {
    [encuesta, setEncuesta] = useState(location.state.encuesta);
    isLoading = false;
  } else {
    [encuesta, isLoading, , setEncuesta] = useFetcher(fetchEncuesta, [itemId]);
  }
  return [encuesta, isLoading, setEncuesta];
};

const EncuestaDetail = ({ match, location }) => {
  const itemId = match.params.id;
  const [encuesta, isLoading, setEncuesta] = retriveEncuestaObj(itemId, location);
  const activityComponent = useRef();
  const [saveEncuestaCall, isSavingEncuesta] = useMutter(patchEncuesta);
  const [encuestaCategories] = useFetcher(fetchEncuestaCategories);

  let responde = null;
  if (encuesta.RespondeAsociados) {
    responde = encuesta.RespondeAsociados;
  }
  if (encuesta.RespondeClientes) {
    responde = encuesta.RespondeClientes;
  }
  if (encuesta.RespondeCandidatos) {
    responde = encuesta.RespondeCandidatos;
  }

  const [modifyingCloseLoop, setModifyingCloseLoop] = useState(false);
  // eslint-disable-next-line prefer-const
  let [closeLoop, setCloseLoop] = useState(encuesta.closeLoop);
  const closeLoopOptions = encuestaCategories["close-loop"]
    ? encuestaCategories["close-loop"]
        .map((item) => {
          return { label: item.text, value: item.id };
        })
        .sort((a, b) => (a.label > b.label ? 1 : -1))
    : [];

  const handleEncuestaSave = async () => {
    const [result] = await saveEncuestaCall([itemId, { closeLoop }]);
    if (result) {
      setEncuesta(result);
      setModifyingCloseLoop(false);
      activityComponent.current.refreshActivities();
    }
  };

  const handleCloseLoopChange = async (selected) => {
    closeLoop = selected.value;
    setCloseLoop(closeLoop);
    await handleEncuestaSave();
  };

  const getNpsColor = (puntaje) => {
    if (puntaje <= 6) {
      return npsColors.error;
    }
    if (puntaje >= 9) {
      return npsColors.success;
    }
    return npsColors.warning;
  };

  return (
    <>
      <Helmet>
        <title>PIN - Encuesta {itemId}</title>
      </Helmet>
      <Breadcrumb title={`Encuesta ${itemId}`} parent="Sistema de Encuesta" backButton />
      <BlurSpinner isLoading={isLoading || isSavingEncuesta}>
        <Container fluid>
          <Row>
            <Col lg="8" className="pb-3">
              <Row>
                <Col lg="12">
                  {/* Status card */}
                  <Card>
                    <CardBody className="row justify-content-center text-center">
                      <Col md="3">
                        <div className="body">
                          {modifyingCloseLoop ? (
                            <>
                              <Button size="xs" color="link" onClick={() => setModifyingCloseLoop(!modifyingCloseLoop)}>
                                <X size="24" />
                              </Button>
                              <StyledSelect
                                name="status"
                                options={closeLoopOptions}
                                onChange={handleCloseLoopChange}
                                value={closeLoopOptions.find((option) => {
                                  return option.value === closeLoop;
                                })}
                              />
                            </>
                          ) : (
                            <>
                              <Button size="xs" color="link" onClick={() => setModifyingCloseLoop(!modifyingCloseLoop)}>
                                <Edit size="24" />
                              </Button>
                              <h4>
                                <span
                                  className="badge"
                                  style={{
                                    fontSize: "unset",
                                    background: `#${encuesta.closeLoopCat ? encuesta.closeLoopCat.color : "fff"}`,
                                  }}
                                >
                                  {encuesta.closeLoopCat ? encuesta.closeLoopCat.text : "-"}
                                </span>
                              </h4>
                            </>
                          )}
                        </div>
                      </Col>
                      <Col md="3">
                        <div className="body">
                          <Flag style={{ color: `#${encuesta.statusCat ? encuesta.statusCat.color : "fff"}` }} />
                          <h4>
                            <span
                              className="badge"
                              style={{
                                fontSize: "unset",
                                background: `#${encuesta.statusCat ? encuesta.statusCat.color : "fff"}`,
                              }}
                            >
                              {encuesta.statusCat ? encuesta.statusCat.text : "-"}
                            </span>
                          </h4>
                        </div>
                      </Col>
                      <Col md="3">
                        <div className="body">
                          <Calendar style={{ color: "var(--orange)" }} />
                          <h4>{encuesta.fechaEnvioStart ? moment.utc(encuesta.fechaEnvioStart).format(humanDateFormat) : "-"}</h4>
                          <p>Fecha de envio</p>
                        </div>
                      </Col>
                      <Col md="3">
                        <div className="body">
                          <Calendar style={{ color: "var(--yellow)" }} />
                          <h4>{encuesta.fechaRespuestaStart ? moment.utc(encuesta.fechaRespuestaStart).format(humanDateFormat) : "-"}</h4>
                          <p>Fecha de Respuesta</p>
                        </div>
                      </Col>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              <Row>
                <Col lg="6">
                  {/* Detail card */}
                  <Card className="h-100 mb-0">
                    <CardHeader className="pt-3 pb-3 d-flex align-items-center">
                      <h6 className="m-0">Detalle:</h6>
                    </CardHeader>
                    <CardBody className="py-3">
                      <div className="text-muted">Socio: </div>
                      <div className="d-flex justify-content-between align-items-center">{responde ? responde.socio : "-"}</div>
                      <hr />
                      <div className="text-muted">Socio ID: </div>
                      <div className="d-flex justify-content-between align-items-center">{responde ? parseInt(responde.cuit, 10) : "-"}</div>
                      <hr />
                      <div className="text-muted">E-Mail: </div>
                      <div className="d-flex justify-content-between align-items-center">{encuesta.email ? encuesta.email : "-"}</div>
                      <hr />
                      <div className="text-muted">Público: </div>
                      <div
                        className="badge"
                        style={{
                          fontSize: "unset",
                          background: `#${encuesta.tipoCat ? encuesta.tipoCat.color : "fff"}`,
                        }}
                      >
                        {encuesta.tipoCat ? encuesta.tipoCat.text : "-"}
                      </div>
                      <hr />
                      <div className="text-muted">Servicio: </div>
                      <div
                        className="badge"
                        style={{
                          fontSize: "unset",
                          background: `#${responde && responde.servicio2Cat ? responde.servicio2Cat.color : "fff"}`,
                        }}
                      >
                        {responde && responde.servicio2Cat ? responde.servicio2Cat.text : "-"}
                      </div>
                      <hr />
                      <div className="text-muted">Sucursal: </div>
                      <div className="d-flex justify-content-between align-items-center">{encuesta.Sucursales ? encuesta.Sucursales.titulo : "-"}</div>
                      <hr />
                      <div className="text-muted">Region: </div>
                      <div className="d-flex justify-content-between align-items-center">
                        {encuesta.Sucursales && encuesta.Sucursales.Region2 ? encuesta.Sucursales.Region2.title : "-"}
                      </div>
                      <hr />
                      <div className="text-muted">Clasificacion: </div>
                      <div
                        className="badge"
                        style={{
                          fontSize: "unset",
                          background: `#${encuesta.clasificacion2Cat ? encuesta.clasificacion2Cat.color : "fff"}`,
                        }}
                      >
                        {encuesta.clasificacion2Cat ? encuesta.clasificacion2Cat.text : "-"}
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                <Col lg="6">
                  {/* Puntaje card */}
                  <Card className="h-100 mb-0">
                    <CardHeader className="pt-3 pb-3 d-flex align-items-center">
                      <h6 className="m-0">Puntaje:</h6>
                    </CardHeader>
                    <CardBody className="py-3" style={{ maxHeight: "615px", overflow: "auto" }}>
                      <ul className="list-unstyled">
                        {puntajes.map((puntaje) => (
                          <li key={puntaje.field} className="pb-3">
                            <div>
                              {puntaje.title} <strong>({parseInt(encuesta[puntaje.field], 10)})</strong>
                            </div>
                            <div className="progress sm-progress-bar">
                              {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
                              <div
                                className="progress-bar"
                                role="progressbar"
                                style={{
                                  width: `${parseInt(encuesta[puntaje.field], 10) * 10}%`,
                                  backgroundColor: `#${getNpsColor(parseInt(encuesta[puntaje.field], 10))}`,
                                }}
                                aria-valuenow={parseInt(encuesta[puntaje.field], 10)}
                                aria-valuemin="0"
                                aria-valuemax="10"
                              />
                              <span className="sr-only">{parseInt(encuesta[puntaje.field], 10)}</span>
                            </div>
                          </li>
                        ))}
                      </ul>
                      <b>Observaciones</b>
                      <div className="normalized_ul">{encuesta.comentarios ? parse(encuesta.comentarios) : ""}</div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>
            <Col lg="4" className="pb-3">
              {/* Activities card */}
              <Activities ref={activityComponent} bodyStyle={{ maxHeight: "742px", overflow: "auto" }} entityId={itemId} entity="encuesta" />
            </Col>
          </Row>
        </Container>
      </BlurSpinner>
    </>
  );
};

export default withRouter(EncuestaDetail);
